<template>
  <div>
    <goods-form ref="goodsForm" :selectGoodsList="goodsList" :order="order" :baseForm="baseForm"/>
    <oms-form-row label="" :span="4" class="mt-10">
      <el-button type="primary" @click="addItem">加入订单</el-button>
    </oms-form-row>
    <goods-list ref="goodsList" :goodsList="goodsList" @editItem="editItem" @deleteItem="deleteItem"/>
  </div>
</template>
<script>
  import GoodsForm from './goods-form';
  import GoodsList from './goods-list';

  export default {
    props: {
      order: Object,
      baseForm: {}
    },
    components: {GoodsForm, GoodsList},
    data() {
      return {
        goodsList: []
      };
    },
    watch: {
      order(val) {
        this.goodsList = val.details || [];
      }
    },
    methods: {
      addItem() {
        const goodsForm = this.$refs.goodsForm;
        goodsForm.$refs.form.validate(valid => {
          if (!valid) return;
          const form = Object.assign({}, goodsForm.form);
          form.unitPrice *= 1;
          // 是否需要选择批号
          if (goodsForm.isShowBatchNumber) {
            let batchNumberList = goodsForm.getBatchNumberList();
            if (!batchNumberList.length) {
              return this.$notify.info('请选择批号');
            }
            if (batchNumberList.some(s => !s.productCount)) {
              return this.$notify.info('已选批号，产品数量不能为空');
            }
            if(batchNumberList.some(s => s.productCount < 0)) {
              return this.$notify.info('输入的产品数量不能为负数');
            }
            batchNumberList.forEach(i => {
              const formItem = Object.assign({}, form);
              formItem.batchNumber = i.batchNumber;
              formItem.batchNumberId = i.batchNumberId;
              formItem.expirationDate = i.expirationDate;
              formItem.amount = i.productCount;
              if(i.supplyManufacturersId) {
                formItem.supplyManufacturersId = i.supplyManufacturersId;
                formItem.supplyManufacturers = i.supplyManufacturersName;
                formItem.supplyManufacturersCode = i.supplyManufacturersCode;
              }
              this.goodsList.push(formItem);
            });
          } else {
            this.goodsList.push(form);
          }
          goodsForm.queryOtherDhsGoods();
          goodsForm.resetForm();
        });
      },
      editItem(item) {
        const goodsForm = this.$refs.goodsForm;
        goodsForm.editForm(item);
        this.deleteItem(item);
      },
      deleteItem(item) {
        this.goodsList = this.goodsList.filter(f => f !== item);
      },
      resetForm() {
        this.$refs.goodsForm.manageGoods = [];
        this.$refs.goodsForm.resetForm();
        this.goodsList = [];
      }
    }
  };
</script>
